import styled from 'styled-components';

import { DotsLoader } from '@sternum/web/components/DotsLoader';
import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const OptionCountText = styled.div`
  color: ${ct({ Light: Colors.GreyDarker, Dark: Colors.GreyDarker })};
`;

export const CountLoaderContainer = styled.div``;

export const CountLoader = styled(DotsLoader)`
  width: 16px;
`;
